export default __webpack_public_path__ + "static/media/leader_notes.593bee09.pdf";